import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {StaticPageImage} from '../../models/cms/static-page-image';

@Injectable({
  providedIn: 'root'
})
export class StaticPageImageService extends AbstractModelService<StaticPageImage> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/static-page-image', StaticPageImage);
  }
}
